import { actionTypes } from '../actions/roulette.action';
const initialState = {
    awards: [],
    award: {},
    result: {
        award: {},
        transaction: {},
        user: {}
    },
    error: {},
    success: false
}

const RouletteReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.awards.data.findIndex(item => item.id === payload.id)
        state.awards.data[index] = payload

        return {
            ...state,
            awards: {
                ...state.awards,
                data: [
                    ...[(index < 0) && payload],
                    ...state.awards.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            awards: state.awards.filter(item => item.id !== payload)
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            award: (payload === 'clear') ? {} : {
                ...state.award,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default RouletteReducer